export function truncateFormatter(str: string, size: number): string {
  if (typeof str !== "string" || typeof size !== "number" || size < 0) {
    return "";
  }

  if (str.length <= size) {
    return str;
  }

  const truncatedStr = str.substring(0, size - 3);
  return truncatedStr + "...";
}
